/* eslint-disable */

const minTabletWidth = 768;
const minDesktopWidth = 1024;

module.exports = {
    minTabletWidth,
    minDesktopWidth,

    // common colors
    'black': '#414141',
    'white': '#fff',
    'green': '#48D597',
    'green-hover': '#8FDBB0',
    'light-cyan': '#e6f5f4',
    'light-grey': '#eee',
    'yellow': '#f0da47',
    'warm-grey': '#faf8f7',
    'grey': '#beb8b8',
    'grey-hover': '#EEEEEE',
    'red': '#F993B9',  // @deprecated - use `pastel-red` instead
    'orange': '#e98c03',
    'pink-100': '#F3E3E9',
    'yellow-100': '#FEF5E1',
    'green-100': '#E2F8EE',
    'purple': '#B6A9F7',
    'brown-gray': '#8E8E8E',
    // New mobile ui kit colors
    'very-light-pink': '#f0f0f0',
    'very-light-pink-two': '#fce7e5',
    'brownish-grey': '#777',
    'jade-green': '#2baf66',
    'orange-yellow': '#ffa000',
    'pastel-red': '#F993B9',
    'tealish': '#26a69a',
    'ice-blue': '#e6f5f4',
    'light-peach': '#d7d6d5',
    'send-message': '#B6A9F7',
    'send-message-hover': '#CAC0FB',

    "link-hover-color": "#48D597",
    "link-detail": "#38c7b9",

    // text colors
    'grey-color':       '#989898',

    // background-color
    'grey-bg':       '#f6f8f7',
    'background-color': '#fff',
    'warning-fill': '#F993B9',
    'light-green': '#e2f3f2',

    // social
    'facebook':      '#23599b',
    'twitter':       '#00aef1',
    'google':        '#fd4d3e',
    'google-blue':   '#4285f4',
    'pinterest':     '#dd0316',
    'vkontakte':     '#4b89af',
    'odnoklassniki': '#ff8f2e',
    'telegram':      '#0088cc',
    'viber':         '#8f5db7',

    // sizes media
    'small-650':     'min-width: 650px', // @deprecated
    'min-tablet':    `min-width: ${minTabletWidth}px`,
    'max-tablet':    `max-width: ${minTabletWidth}px`,
    'min-desktop':   `min-width: ${minDesktopWidth}px`,
    'max-desktop':   `max-width: ${minDesktopWidth}px`,


    'min-medium': 'min-width: 940px',
    'max-medium': 'max-width: 940px',

    'modal-max-width': '600px',

    'min-small-340': 'min-width: 340px',

    // components
    'input-border-color': '#beb8b8',
    'input-background-color': '#fff',
    'input-active-color': '#48D597',
    'input-color': "#414141",
    "form-error": "#e9594c",
    "warning-form-bg": "#fef5e1",
    "tip-color": "#777777", // @deprecated - use `brownish-grey` instead

    // button
    'button-color': '#414141',
    'button-background-color': '#48D597',
    'disabled-button-background-color': '#8FDBB0',
    'bordered-button-active-border-color': '#2ab7aa',
    'bordered-button-border-color': '#26a69a',

    // text
    'text-color': '#333',
    'text-muted': '#aaa',

    //common
    'indent':  '20px',
    'page-max-width':  '1200px',
    'font-family': "'PP Object Sans', Arial, Helvetica, sans-serif",
    'line-height': '1.25',
    'font-size': '14px',

    // z-index
    'my-sales-sticky-bar-z-index': 90,
    'desktop-profile-actions-z-index': 110,
    'mobile-bottom-navbar-z-index': 110,
    'mobile-top-navbar-z-index': 110,
    // Have to be higher than navigation !
    'mobile-feed-filters-z-index': 120,
    'mobile-bottom-order-actions-z-index': 120,
    'mobile-product-sticky-bar-z-index': 130,
    'desktop-navbar-z-index': 150,
    'mobile-sidebar-z-index': 150,
    'namespace-categories-z-index': 150,
    'select-mobile-portal-z-index': 160,
    'modal-overlay-z-index': 290,
    'shafa-loader-z-index': 200,
    'toast-container-z-index': 291,
    'animated-page-banner-z-index': 220,
};
